var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
var AppStyles = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 400;\n  .h1,\n  .h2,\n  .h3,\n  .h4,\n  .h5,\n  .h6,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-family: ", ";\n    font-weight: 500;\n  }\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 400;\n  .h1,\n  .h2,\n  .h3,\n  .h4,\n  .h5,\n  .h6,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-family: ", ";\n    font-weight: 500;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.generalContent.text.main.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamilies.ffMain;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamilies.ffAlt;
});
export default AppStyles;
var templateObject_1;
//# sourceMappingURL=AppStyles.js.map